<div class="row">
  <div class="col-12 col-md-9">
    <div class="row mb-2">
      <div class="col-12 col-md-4">
        <select id="sel_timeweek"
                class="form-select form-select-sm"
                [(ngModel)]="gridFilters.timeWeekKey"
                (change)="filterGridData()">
          <option value="">-- Choose Week --</option>
          <option *ngFor="let week of listTimeWeeks; trackBy: trackByFn" [value]="week.id">Week {{ week.wk }}: {{ week.wkstart }} - {{week.wkend}}</option>
        </select>
      </div>
      <div class="col-12 col-md-8 m-0">
        <i class="fas fa-fw fa-lg fa-info-circle c_orange mt-3" title="Review previous weeks data using this filter"></i>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <app-form-entry (parentRefresh)="refreshEntryGrid($event)" (parentGridReset)="resetGrid($event)"></app-form-entry>
      </div>
    </div>
    <div class="row my-2">
      <div class="col-12 col-md-3 text-center">
        <div class="total_label p-2">
          Total: <span class="ms-1">{{scoreCards.total}}</span>
        </div>
      </div>
      <div class="col-12 col-md-3 text-center">
        <div class="billable_label p-2">
          Billable: <span class="ms-1">{{scoreCards.billable}}</span>
        </div>
      </div>
      <div class="col-12 col-md-3 text-center">
        <div class="internal_label p-2">
          Non-Billable: <span class="ms-1">{{scoreCards.internal}}</span>
        </div>
      </div>

      <div class="col-12 col-md-3">
          <input type="text" [(ngModel)]="gridFilters.searchText" placeholder="Search Time Entries"
                 class="form-control form-control-sm"
                 (input)="searchChange()" />
      </div>
    </div>
    <div class="row my-2">
      <div class="col-12">
        <div class="grid_sizer" id="sizeTimeEntries" style="height:33vh;min-height:33vh">
          <ag-grid-angular class="ag-theme-alpine"
                           [rowData]="rowData"
                           [columnDefs]="columnDefs"
                           [getRowStyle]="getRowStyle"
                           [rowHeight]="28"
                           [headerHeight]="32"
                           (gridReady)="onGridReady($event)"
                           [rowSelection]="rowSelection"
                           (selectionChanged)="onSelectionChanged($event)"
                           [pagination]="false"
                           [paginationAutoPageSize]=pageSize
                           [animateRows]="true"
                           [groupDefaultExpanded]="-1"
                           [groupDisplayType]="'groupRows'"
                           [groupRowRendererParams]="groupRowRendererParams"
                           [suppressAggFuncInHeader]="true"
                           style="width: 100%;height:100%;border:0 !important">
          </ag-grid-angular>

        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-3">
    <div class="mb-3">
      <div class="card">
        <div class="card-body bg_green text-center">
          Need Help?  <a href="slack://welara.slack.com/archives/C08K0AE3F39" class="bolder">#hourglass-feedback</a>
        </div>
      </div>
    </div>
    <div id="entryCalendar" class="scroll_div radius5 border mb-3" style="height:75vh!important;border-color:var(--welarasand) !important" *ngIf="(authUser == impersonatedUser)">
      <app-calendar-slim (calendarToEntry)="populateFromCalendar($event)" [targetObject]="'entryCalendar'"></app-calendar-slim>
    </div>
  </div>
</div>

<div class="backdrop" [ngStyle]="{'display':showModal}"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':showModal}" id="entryModal">
  <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="container-fluid p-0">
          <div class="row m-0 p-0">
            <div class="col-12 col-md-6 p-0 modal-title"></div>
            <div class="col-12 col-md-6 p-0 text-end">
              <button type="button" class="btn btn-sm btn-light my-1" alt="Close" title="Close" (click)="toggleModal('hide')">
                <i class="fas fa-fw fa-times"></i>
              </button>
            </div>
          </div>
        </div>
        <span></span>
      </div>
      <div class="modal-body">
        <app-form-tasks-entry id="ctlTaskAdd"
          (useExistingTask)="populateFromExisting($event)"
          (closeModal)="handleTaskChanges($event)"
          (refreshData)="refreshEntryGrid($event)"
          >
        </app-form-tasks-entry>
      </div>
      <div class="modal-footer text-center d-none">
        <button type="button" class="btn btn-dark my-1" title="Save">
          <i class="fas fa-fw fa-save"></i>
        </button>
        <button type="button" class="btn btn-light my-1" alt="Close" title="Close">
          <i class="fas fa-fw fa-times"></i>
        </button>
      </div>
    </div>
  </div>
</div>
